import React from 'react';
import * as S from './styles';
import { BooleanProperty } from './types';

type Props = {
  property: BooleanProperty;
  booleanTrueText: string;
  booleanFalseText: string;
};

export function BooleanPropertyValue({
  property,
  booleanTrueText,
  booleanFalseText,
}: Props) {
  if (property.boolean === true) {
    return (
      <S.BooleanPropertyValue data-testid="boolean-true-icon">
        <S.BooleanTrueIcon />
        {`\u00A0${booleanTrueText}`}
      </S.BooleanPropertyValue>
    );
  }

  if (property.boolean === false) {
    return (
      <S.BooleanPropertyValue data-testid="boolean-false-icon">
        <S.BooleanFalseIcon />
        {`\u00A0${booleanFalseText}`}
      </S.BooleanPropertyValue>
    );
  }

  return (
    <S.BooleanPropertyValue data-testid="boolean-unknown-icon">
      <S.BooleanUnknownIcon />
    </S.BooleanPropertyValue>
  );
}
